<thumbnail-selector 
	*ngIf="mediaclip && (mediaclip.mediatype === 'video' || mediaclip.mediatype === 'image' || mediaclip.mediatype === 'audio' || !mediaclip.id)"
	[asset]="asset"
	(onChange)="thumbnailsChanged($event)"
	[thumbnails]="mediaclip?.thumbnails"
	[assetTitle]="mediaclip.title"
	[entity]="mediaclip"
></thumbnail-selector>
